import { PresentUser, AnonymousUser, Auth, PresenceUser } from 'types'

export const excludeUserFromPresentUsers = (user: Auth | undefined, presentUsers: PresenceUser[]) => {
  if (!user) {
    return presentUsers
  }

  return presentUsers.filter((u) => {
    if (u === null) return false

    if ((u as PresentUser).id) {
      return (u as PresentUser).id !== user.id
    }

    if ((u as AnonymousUser).uuid) {
      return (u as AnonymousUser).uuid !== user.uid
    }

    return true
  })
}
